import React from "react";
import { Container, Card } from "react-bootstrap";
import "../components/css/Rooms.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";
import { Link } from "react-router-dom";

import room1 from "../media/images/rooms/FH_UG-201.jpg";
import room2 from "../media/images/rooms/002.jpg";
import room3 from "../media/images/rooms/008.jpg";
import room4 from "../media/images/rooms/room4.jpg";

const rooms = [
  { title: "Standard Room" ,price: "$150",price2:"$100", night:"PER NIGHT", zoom:"🔍 View Details",  image: room1 },
  { title: "Deluxe Double Room" ,price: "$180",price2:"$120", night:"PER NIGHT", zoom:"🔍 View Details", image: room2 },
  { title: "Executive Room" ,price: "$200",price2:"$150", night:"PER NIGHT", zoom:"🔍 View Details", image: room3 },
  { title: "VIP Room" ,price: "$230",price2:"$180", night:"PER NIGHT", zoom:"🔍 View Details", image: room4 },
];

const Rooms = () => {
  return (
    <section className="rooms-section py-5">
      <Container>
        <h2 className="text-center fw-bold mb-3" data-aos="fade-up">OUR ROOMS</h2>

        <p className="allroom text-center mb-5" data-aos="fade-up" data-aos-delay="200">
          All rooms are fully equipped with an individually controlled air
          condition system, attached with a full private bathroom, a balcony
          overseeing the spectacular view, satellite television, fridge, wire
          and wireless internet access.
        </p>

        <Swiper
          modules={[Autoplay]}
          spaceBetween={30}
          slidesPerView={3}
          loop={true}

          speed={1200} // 🔥 smooth

          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}

          breakpoints={{
            0: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            992: { slidesPerView: 3 },
          }}
        >
          {rooms.map((room, index) => (
            <SwiperSlide key={index} >
  <Card className="room-card">

    {/* IMAGE */}
    <div className="image-wrapper" data-aos="zoom-in" data-aos-delay={index * 200}>
      <Card.Img
        variant="top"
        src={room.image}
        className="room-image"
      />
    </div>

    {/* BOTTOM CONTENT */}
    <div className="room-info">
      <h3>{room.title}</h3>

      <div className="room-bottom">
        <div className="price">
          <span className="old">{room.price}</span>
          <span className="new">{room.price2}</span>
          <span className="per">{room.night}</span>
        </div>

        <div className="view">
          {room.zoom}
        </div>
      </div>
    </div>

  </Card>
</SwiperSlide>
          ))}
        </Swiper>
      </Container>
      <div className="text-center">
      <Link to="/rooms" className="story-link">
            View All Rooms →
          </Link>
      </div> 
    </section>
  );
};

export default Rooms;